var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavaScriptLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4525",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.4 291.5",
    width: 2199,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#d4b830}.st1,.st2{opacity:.986;fill:#ebebeb;fill-opacity:0;enable-background:new}.st2{fill-opacity:.9216}.st3{fill:#fdd83c}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5193",
    transform: "translate(4.988 -113.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5113",
    className: "st0",
    d: "M18.8 375.4L-5 113.4l256.4.1-23.6 261.7L123 404.8 18.8 375.4zm189.7-14.3l19.9-224.4h-105l.8 247.5 84.3-23.1zm-94.9-191.5H88.1l-.3 134.3-49.5-13.5.1 30.7 75.2 20.3V169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5159",
    className: "st1",
    d: "M105.2 338.9c-3.3-1-19.6-5.4-36.2-9.9l-30.1-8.1v-15.1c0-14.8 0-15.1 1.5-14.6.8.3 11.8 3.3 24.4 6.8l22.9 6.3.2-67 .2-67h25v85.2c0 67.7-.2 85.2-.9 85.2-.5-.1-3.7-.9-7-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5157",
    className: "st2",
    d: "M38.4 321.1l-.1-30.7s31.6 8.9 49.5 13.5l.3-134.2h25.5v171.7l-75.2-20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5117",
    className: "st3",
    d: "M123.4 136.6h105L208.5 361l-85.1 23.1V136.6zm79.7 186.8l6.9-83.9-51 5.7v-44.8l54.4-.2 2.2-30.6-82.1.4 1.1 111.4 49.6-8.5-.7 24.8-50 13.3.5 30.4 69.1-18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScriptLogo);
export default __webpack_public_path__ + "static/media/JavaScript-logo.ba40d6a9629bf521391e764a593f9df3.svg";
export { ForwardRef as ReactComponent };